class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    // Lock the page without it jumping sideways: the scrollbar's width stays as padding, so the
    // page underneath keeps its layout and doesn't have to be laid out and repainted again.
    // Measured before anything changes, while the layout is still clean.
    const gutter = window.innerWidth - document.documentElement.clientWidth;
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    if (gutter > 0) document.body.style.paddingRight = `${gutter}px`;
    document.body.classList.add('overflow-hidden');
    this.setOverlayOpen(true);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.body.style.removeProperty('padding-right');
    this.setOverlayOpen(false);
  }

  // The theme editor can re-render the header while search is open; don't leave the page locked.
  disconnectedCallback() {
    if (!this.isOpen()) return;
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.body.style.removeProperty('padding-right');
    this.setOverlayOpen(false);
  }

  // Lets the page pause what can't be seen under the overlay (hero autoplay, card glints).
  // Only on a real change: the sticky header calls close() on every scroll while hiding.
  setOverlayOpen(open) {
    const root = document.documentElement;
    if (root.classList.contains('hive-overlay-open') === open) return;
    root.classList.toggle('hive-overlay-open', open);
    document.dispatchEvent(new CustomEvent('hive:overlay', { detail: { open } }));
  }
}

customElements.define('details-modal', DetailsModal);
